// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2nLIy","inner":"Footer_inner__7ZKPc"};